import { render } from "./remarkDialog.vue?vue&type=template&id=ee4bad2c&scoped=true"
import script from "./remarkDialog.vue?vue&type=script&lang=js"
export * from "./remarkDialog.vue?vue&type=script&lang=js"

import "./remarkDialog.vue?vue&type=style&index=0&id=ee4bad2c&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee4bad2c"]])

export default __exports__